import { useState, useEffect } from 'react';
import {
  Stack,
  Paper,
  TextField,
  Button,
  Typography,
  InputAdornment,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  List,
  ListItem,
  ListItemText,
  Chip,
  Avatar,
  CircularProgress,
  Alert,
} from '@mui/material';
import {
  Title,
  Description,
  Schedule,
  Group,
  VideoCall,
  Logout,
  CheckCircle,
} from '@mui/icons-material';
import { Post, Get } from '../../Axios/AxiosFunctions';
import Loader from '../../Component/Loader';
import { toast } from 'react-toastify';
import './MainZoom.css';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { apiUrl } from '../../config/apiUrl';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { DropDown } from '../../Component/DropDown/DropDown';
import useDebounce from '../../CustomHooks/useDebounce';
import { useSearchParams, useNavigate } from 'react-router-dom';

/**
 * CreateMeeting component with Zoom authentication
 */
const CreateMeeting = () => {
  // State management
  const [meetingData, setMeetingData] = useState({
    title: '',
    description: '',
    date: '',
    time: '',
    duration: '30',
    participants: '',
  });
  
  const dispatch = useDispatch();
  // const {
  //   access_token: accessToken,
  //   company_id: companyId,
  //   outlookAuthenticated: outlookAuthenticated,
  // } = useSelector((state) => state?.authReducer);

  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [filteredEmails, setFilteredEmails] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [contactsModalOpen, setContactsModalOpen] = useState(false);
  const [contactsOptions, setContactsOptions] = useState([]);
  const [contactsLoading, setContactsLoading] = useState(false);
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [contactsSearch, setContactsSearch] = useState('');
  
  // Zoom authentication state
  const [zoomConnected, setZoomConnected] = useState(false);
  const [zoomUserInfo, setZoomUserInfo] = useState(null);
  const [checkingZoomStatus, setCheckingZoomStatus] = useState(true);
  const [zoomLoading, setZoomLoading] = useState(false);


  const [syncLoading, setSyncLoading] = useState(false);
	const [syncResult, setSyncResult] = useState(null);
	const [syncMessage, setSyncMessage] = useState(null); // { severity, text } for the inline banner

	const [zoomStatus, setZoomStatus] = useState(null);
const [isZoomAuthenticated, setIsZoomAuthenticated] = useState(false);


  // Router hooks
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Redux state
  const {
    access_token: accessToken,
    user,
    company_id: companyId,
  } = useSelector((state) => state?.authReducer);
  
  const userId = user?._id;
  const debouncedContactsSearch = useDebounce(contactsSearch, 700);

  /**
   * Check for OAuth callback on component mount
   */
  useEffect(() => {
    const handleOAuthCallback = async () => {
      const message = searchParams.get('message');
      const error = searchParams.get('error');
      
      if (message) {
        toast.success(decodeURIComponent(message));
        // Remove query params from URL
        navigate(window.location.pathname, { replace: true });
        // Refresh Zoom status
        await checkZoomConnectionStatus();
      } else if (error) {
        toast.error(decodeURIComponent(error));
        navigate(window.location.pathname, { replace: true });
        setZoomConnected(false);
      }
    };

    handleOAuthCallback();
  }, [searchParams, navigate]);

  /**
   * Check Zoom connection status on component mount
   */
  useEffect(() => {
    checkZoomConnectionStatus();
  }, [userId, accessToken]);

  /**
   * Check if user is connected to Zoom
   */
  // const checkZoomConnectionStatus = async () => {
  //   if (!userId || !accessToken) {
  //     setCheckingZoomStatus(false);
  //     return;
  //   }

  //   try {
  //     setCheckingZoomStatus(true);
  //     const response = await Get(
  //       `${apiUrl}/api/v1/zoom/oauth/status?user_id=${userId}`,
  //       accessToken
  //     );
      
  //     const isConnected = response.data?.connected || response.data?.hasValidToken;
  //     setZoomConnected(isConnected);
      
  //     if (isConnected) {
  //       await fetchZoomUserProfile();
  //     }
  //   } catch (error) {
  //     console.error('Failed to check Zoom status:', error);
  //     setZoomConnected(false);
  //   } finally {
  //     setCheckingZoomStatus(false);
  //   }
  // };

  const checkZoomConnectionStatus = async () => {
  if (!userId || !accessToken) {
    setCheckingZoomStatus(false);
    return;
  }

  try {
    setCheckingZoomStatus(true);
    console.log('Checking Zoom connection status for user:', userId);
    
    const response = await Get(
      `${apiUrl}/api/v1/zoom/oauth/status?user_id=${userId}`,
      accessToken
    );
    
    console.log('Zoom status response:', response.data);
    
    const isConnected = response.data?.connected || response.data?.hasValidToken;
    setZoomConnected(isConnected);
    
    if (isConnected) {
      await fetchZoomUserProfile();
    }
  } catch (error) {
    console.error('Failed to check Zoom status:', error);
    setZoomConnected(false);
  } finally {
    setCheckingZoomStatus(false);
  }
};

  /**
   * Fetch Zoom user profile
   */
  const fetchZoomUserProfile = async () => {
    try {
      const response = await Get(
        `${apiUrl}/api/v1/zoom/user/profile?user_id=${userId}`,
        accessToken
      );
      setZoomUserInfo(response.data);
    } catch (error) {
      console.error('Failed to fetch Zoom profile:', error);
    }
  };

  /**
   * Handle Zoom login redirect
   */
  // const handleZoomLogin = () => {
  //   try {
  //     setZoomLoading(true);
  //     // Store current path for potential redirect back
  //     sessionStorage.setItem('preZoomAuthPath', window.location.pathname);
      
  //     const authUrl = `${apiUrl}/api/v1/zoom/oauth/redirect?user_id=${userId}`;
  //     window.location.href = authUrl;
  //   } catch (error) {
  //     console.error('Zoom login failed:', error);
  //     toast.error('Failed to initiate Zoom login');
  //     setZoomLoading(false);
  //   }
  // };


//   const handleZoomLogin = () => {
//   try {
//     setZoomLoading(true);
    
//     const clientId = 'Uu1om4oQRWSSHHEcyz7yNA'; // Get from backend or env
//     const redirectUri = encodeURIComponent('http://localhost:3016/api/v1/zoom/oauth/callback');
    
//     const authUrl = `https://zoom.us/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}`;
    
//     window.location.href = authUrl;
//   } catch (error) {
//     console.error('Zoom login failed:', error);
//     toast.error('Failed to initiate Zoom login');
//     setZoomLoading(false);
//   }
// };

  const handleZoomLogin = async () => {
  try {
    setZoomLoading(true);
    // Store current path for potential redirect back
    sessionStorage.setItem('preZoomAuthPath', window.location.pathname);

    // Ask the backend (signed in) for the Zoom sign-in link, then go there.
    const res = await axios.get(`${apiUrl}/api/v1/zoom/oauth/url`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    if (!res?.data?.url) throw new Error('No Zoom sign-in link');
    window.location.href = res.data.url;
  } catch (error) {
    console.error('Zoom login failed:', error);
    toast.error('Failed to initiate Zoom login');
    setZoomLoading(false);
  }
};


  /**
   * Handle Zoom logout
   */
  const handleZoomLogout = async () => {
    try {
      setZoomLoading(true);
      const response = await Get(
        `${apiUrl}/api/v1/zoom/oauth/disconnect?user_id=${userId}`,
        accessToken
      );
      
      if (response.data?.success) {
        setZoomConnected(false);
        setZoomUserInfo(null);
        toast.success('Disconnected from Zoom successfully');
      } else {
        throw new Error(response.data?.error || 'Logout failed');
      }
    } catch (error) {
      console.error('Zoom logout failed:', error);
      toast.error(error.message || 'Failed to disconnect from Zoom');
    } finally {
      setZoomLoading(false);
    }
  };

  /**
   * Fetches all users from the backend
   */
  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await Get(
      `${apiUrl}/api/v1/users/all`,
      accessToken,
      companyId,
      true,
      (err) => {
        console.error('User Fetch Error:', err);
      },
    );
      if (res?.data) {
        setUsers(res.data);
      }
    } catch (error) {
      console.error('User Fetch Error:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  useEffect(() => {
    if (meetingData.participants) {
      const lastEntry = meetingData.participants.split(',').pop().trim();
      if (lastEntry) {
        const filtered = users.filter(
          (user) =>
            user.email.toLowerCase().includes(lastEntry.toLowerCase()) ||
            `${user.firstName} ${user.lastName}`
              .toLowerCase()
              .includes(lastEntry.toLowerCase()),
        );
        setFilteredEmails(filtered);
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    } else {
      setShowSuggestions(false);
    }
  }, [meetingData.participants, users]);

  /**
   * Handles changes to the meeting form fields
   */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setMeetingData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  /**
   * Parses the participants input string
   */
  const parseParticipants = (input) => {
    const items = input
      .split(',')
      .map((item) => item.trim())
      .filter((item) => item);
    const emails = [];
    const numbers = [];

    items.forEach((item) => {
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(item)) {
        emails.push(item);
      } else if (/^\+?[\d\s-]+$/.test(item)) {
        numbers.push(item.replace(/\D/g, ''));
      }
    });

    return { emails, numbers };
  };

  /**
   * Copy text to clipboard
   */
  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    toast.success('Link copied to clipboard!', { autoClose: 3000 });
  };

  /**
   * Handle form submission
   */
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    let join_url = '';

    try {
      const { emails, numbers } = parseParticipants(meetingData.participants);

      if (emails.length === 0 && numbers.length === 0) {
        throw new Error('Please enter at least one valid email or phone number');
      }

      const crmUserEmail = user?.email || '';
      if (!crmUserEmail) {
        throw new Error('Authenticated user email not found.');
      }

      const payload = {
        organizerId: user._id,
        organizerFname: user.firstName,
        organizerLname: user.lastName,
        organizerEmail: user.email,
        topic: meetingData.title,
        start_date: meetingData.date,
        start_time: meetingData.time,
        duration: parseInt(meetingData.duration),
        emails,
        numbers,
        crmUserEmail,
        useUserAccount: true, // Use user's Zoom account
        userId: userId, // Pass user ID for token retrieval
      };

      const response = await Post(
        `${apiUrl}/api/v1/zoom/create-meeting`,
        payload,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      if (!response) {
        throw new Error('No response received from server');
      }

      if (response.data?.success !== true) {
        throw new Error(response.data?.message || 'Meeting creation failed');
      }

      const zoomMeeting = response.data?.meeting;
      join_url = zoomMeeting?.join_url;

      toast.success(
        (t) => (
          <div
            className="flex flex-col gap-1 cursor-pointer"
            onClick={() => {
              copyToClipboard(join_url);
              toast.dismiss(t.id);
            }}
          >
            <div className="flex items-center gap-2">
              <span>Meeting scheduled successfully!</span>
            </div>
            <p className="text-xs text-gray-400">Click to copy link</p>
          </div>
        ),
        {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 6000,
        },
      );

      setMeetingData({
        title: '',
        description: '',
        date: '',
        time: '',
        duration: '30',
        participants: '',
      });
    } catch (error) {
      toast.error(error.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      console.error('Meeting creation error:', error);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Fetches contacts for the modal
   */
  const fetchContacts = async (search = '') => {
    if (!search) {
      setContactsOptions([]);
      return;
    }
    setContactsLoading(true);
    try {
      // const url = `${apiUrl}/api/v1/users/all?search=${encodeURIComponent(search)}`;

      const res = await Get(
      `${apiUrl}/api/v1/users/all?search=${encodeURIComponent(search)}`,
      accessToken,
      companyId,
      true,
      (err) => {
        console.error('User Fetch Error:', err);
      },
    );

      
      // const res = await Get(url, accessToken);
      if (res?.data) {
        setContactsOptions(res.data);
      } else {
        setContactsOptions([]);
      }
    } catch (error) {
      console.error('Contacts Fetch Error:', error);
      setContactsOptions([]);
    } finally {
      setContactsLoading(false);
    }
  };

  useEffect(() => {
    if (contactsModalOpen) {
      fetchContacts(debouncedContactsSearch);
    }
  }, [debouncedContactsSearch, contactsModalOpen]);

  /**
   * Add selected contacts to participants
   */
  const handleAddContactsToParticipants = () => {
    const current = meetingData.participants
      .split(',')
      .map((e) => e.trim())
      .filter(Boolean);
    
    const newEmails = (selectedContacts || [])
      .map((c) => c.email)
      .filter((email) => email && !current.includes(email));
    
    const all = [...current, ...newEmails];
    setMeetingData((prev) => ({
      ...prev,
      participants: all.join(', '),
    }));
    setContactsModalOpen(false);
    setSelectedContacts([]);
    setContactsSearch('');
  };




  const checkZoomStatus = async () => {
  try {
    const response = await axios.get(
      `${apiUrl}/api/v1/zoom/user/${userId}/zoom-status`,
      { headers: { Authorization: `Bearer ${accessToken}` } }
    );
    
    setZoomStatus(response.data);
    setIsZoomAuthenticated(response.data.isAuthenticated);
    
    if (!response.data.isAuthenticated) {
      alert('Please connect your Zoom account first to sync call summaries');
    }
  } catch (error) {
    console.error('Error checking Zoom status:', error);
  }
};

useEffect(() => {
  checkZoomStatus();
}, [userId]);

const syncCallSummaries = async () => {
  if (!isZoomAuthenticated) {
    setSyncMessage({ severity: 'warning', text: 'Please connect your Zoom account first.' });
    return;
  }

  setSyncLoading(true);
  setSyncResult(null);
  setSyncMessage(null);

  try {
    const response = await axios.post(`${apiUrl}/api/v1/zoom/sync-call-summaries`, {
      userId: userId,
      zoomuserid: zoomStatus.zoomProfile.id,
      // Optionally specify date range
      // fromDate: '2025-09-01',
      // toDate: '2025-09-08'
    }, { headers: { Authorization: `Bearer ${accessToken}` } });

    setSyncResult(response.data);

    if (response.data.success) {
      setSyncMessage({
        severity: 'success',
        text: `Successfully processed ${response.data.processed} call ${response.data.processed === 1 ? 'summary' : 'summaries'}.`,
      });
    } else {
      setSyncMessage({ severity: 'error', text: response.data.message || 'Failed to sync call summaries.' });
    }
  } catch (error) {
    console.error('Error syncing call summaries:', error);
    const data = error.response?.data;

    if (data?.requiresAuth || data?.requiresReauth) {
      setSyncMessage({ severity: 'warning', text: data.message || 'Zoom authentication required. Please reconnect your Zoom account.' });
    } else if (data?.noZoomPhone) {
      // Expected case: this account has no Zoom Phone line — show the server's explanation
      setSyncMessage({ severity: 'info', text: data.message });
    } else {
      setSyncMessage({ severity: 'error', text: data?.message || data?.error || 'Something went wrong syncing call summaries. Please try again.' });
    }
  } finally {
    setSyncLoading(false);
  }
};

  /**
   * Render Zoom authentication section
   */
  const renderZoomAuthSection = () => {
    if (checkingZoomStatus) {
    return (
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        p: 4,
        flexDirection: 'column',
        gap: 2
      }}>
        <CircularProgress size={40} />
        <Typography variant="body1" color="text.secondary">
          Checking Zoom connection...
        </Typography>
      </Box>
    );
  }

    if (!zoomConnected) {
      return (
        <Box
          sx={{
            maxWidth: 800,
            mx: 'auto',
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '300px',
            textAlign: 'center',
          }}
        >
          <VideoCall sx={{ fontSize: 64, color: '#2D8CFF', mb: 2 }} />
          <Typography variant="h5" gutterBottom sx={{ mb: 1, fontWeight: 600 }}>
            Connect Your Zoom Account
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: '400px' }}>
            Connect your Zoom account to schedule and manage meetings directly from our platform
          </Typography>
          <Button
            variant="contained"
            onClick={handleZoomLogin}
            startIcon={zoomLoading ? <CircularProgress size={20} color="inherit" /> : <VideoCall />}
            disabled={zoomLoading}
            sx={{
              backgroundColor: '#2D8CFF',
              fontFamily: "'Open Sans', sans-serif",
              fontWeight: '600',
              '&:hover': {
                backgroundColor: '#1a75ff',
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(45, 140, 255, 0.3)',
              },
              padding: '12px 32px',
              fontSize: '16px',
              borderRadius: '8px',
              transition: 'all 0.2s ease-in-out',
            }}
          >
            {zoomLoading ? 'Connecting...' : 'Connect Zoom Account'}
          </Button>
        </Box>
      );
    }

    return (
      <Box sx={{ p: 3 }}>
        <Paper
          elevation={2}
          sx={{
            p: 3,
            mb: 3,
            bgcolor: 'success.light',
            background: 'linear-gradient(135deg, #e8f5e8 0%, #c8e6c9 100%)',
            borderRadius: 3,
            border: '1px solid #4caf50',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar 
                src={zoomUserInfo?.pic_url} 
                sx={{ 
                  width: 56, 
                  height: 56,
                  border: '3px solid #4caf50'
                }}
              >
                {zoomUserInfo?.first_name?.[0]}{zoomUserInfo?.last_name?.[0]}
              </Avatar>
              <Box>
                <Typography variant="h6" fontWeight="bold" color="success.dark">
                  {zoomUserInfo?.first_name} {zoomUserInfo?.last_name}
                </Typography>
                <Typography variant="body2" color="success.main" sx={{ mb: 1 }}>
                  {zoomUserInfo?.email}
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <CheckCircle sx={{ fontSize: 16, color: '#4caf50' }} />
                  <Typography variant="caption" color="success.dark">
                    Connected to Zoom
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Button
              variant="outlined"
              color="error"
              startIcon={zoomLoading ? <CircularProgress size={16} /> : <Logout />}
              onClick={handleZoomLogout}
              disabled={zoomLoading}
              sx={{
                borderRadius: '20px',
                textTransform: 'none',
                fontWeight: '500',
              }}
            >
              {zoomLoading ? 'Disconnecting...' : 'Disconnect'}
            </Button>
          </Box>
        </Paper>
      </Box>
    );
  };

  if (loading) {
    return <Loader />;
  }

  return (
    <>
      <div className="zoom-widget-container">
        <div className="zoom-widget">
          {renderZoomAuthSection()}
          
          {zoomConnected && (
          	<>


<Box sx={{ mt: 3, p: 2, border: '1px solid #ddd', borderRadius: 1 }}>
  <Typography variant="h6" gutterBottom>
    Sync Call Summaries
  </Typography>
  
  <Button 
    variant="contained" 
    color="primary" 
    onClick={syncCallSummaries}
    disabled={syncLoading || !isZoomAuthenticated}
    sx={{ mb: 2 }}
  >
    {syncLoading ? 'Syncing...' : 'Sync Call Summaries (Last 7 Days)'}
  </Button>

  {!isZoomAuthenticated && (
    <Typography variant="body2" color="error" sx={{ mb: 2 }}>
      Please connect your Zoom account first
    </Typography>
  )}

  {syncMessage && (
    <Alert
      severity={syncMessage.severity}
      onClose={() => setSyncMessage(null)}
      sx={{ mb: 2, whiteSpace: 'pre-line' }}
    >
      {syncMessage.text}
    </Alert>
  )}

  {syncResult && (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body2">
        <strong>Results:</strong> {syncResult.processed} processed,{' '}
        {syncResult.results.filter(r => r.status === 'success').length} successful
      </Typography>
      
      {syncResult.results.filter(r => r.status === 'error').length > 0 && (
        <Typography variant="body2" color="error">
          {syncResult.results.filter(r => r.status === 'error').length} errors
        </Typography>
      )}
    </Box>
  )}
</Box>
          	</>
)}
          {zoomConnected && (
            <Box
              sx={{
                width: '100%',
                maxWidth: 800,
                mx: 'auto',
                p: 3,
                minWidth: { xs: '100%', sm: 600 },
              }}
            >
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  backgroundColor: 'white',
                  borderRadius: '12px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                  width: '100%',
                  border: '1px solid #e0e0e0',
                }}
              >
                <Typography variant="h5" gutterBottom sx={{ mb: 3, fontWeight: 600, color: '#2c3e50' }}>
                  Schedule New Meeting
                </Typography>
                
                <form onSubmit={handleSubmit}>
                  <Stack spacing={3} sx={{ width: '100%' }}>
                    <TextField
                      fullWidth
                      label="Meeting Title"
                      name="title"
                      value={meetingData.title}
                      onChange={handleChange}
                      required
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Title sx={{ color: '#1284D3' }} />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiInputBase-root': {
                          borderRadius: '8px',
                        },
                      }}
                    />

                    <TextField
                      fullWidth
                      label="Description"
                      name="description"
                      value={meetingData.description}
                      onChange={handleChange}
                      multiline
                      rows={3}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Description sx={{ color: '#1284D3' }} />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        '& .MuiInputBase-root': {
                          borderRadius: '8px',
                        },
                      }}
                    />

                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      spacing={2}
                      sx={{ width: '100%' }}
                    >
                      <TextField
                        fullWidth
                        label="Date"
                        name="date"
                        type="date"
                        value={meetingData.date}
                        onChange={handleChange}
                        required
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Schedule sx={{ color: '#1284D3' }} />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ 
                          minWidth: { xs: '100%', sm: 'auto' },
                          '& .MuiInputBase-root': {
                            borderRadius: '8px',
                          },
                        }}
                      />

                      <TextField
                        fullWidth
                        label="Time"
                        name="time"
                        type="time"
                        value={meetingData.time}
                        onChange={handleChange}
                        required
                        InputLabelProps={{ shrink: true }}
                        sx={{ 
                          minWidth: { xs: '100%', sm: 'auto' },
                          '& .MuiInputBase-root': {
                            borderRadius: '8px',
                          },
                        }}
                      />

                      <FormControl
                        fullWidth
                        sx={{ 
                          minWidth: { xs: '100%', sm: 'auto' },
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                          },
                        }}
                      >
                        <InputLabel>Duration</InputLabel>
                        <Select
                          name="duration"
                          value={meetingData.duration}
                          onChange={handleChange}
                          label="Duration"
                        >
                          <MenuItem value="15">15 min</MenuItem>
                          <MenuItem value="30">30 min</MenuItem>
                          <MenuItem value="45">45 min</MenuItem>
                          <MenuItem value="60">60 min</MenuItem>
                        </Select>
                      </FormControl>
                    </Stack>

                    <Box position="relative">
                      <TextField
                        fullWidth
                        label="Participants"
                        name="participants"
                        value={meetingData.participants}
                        onChange={handleChange}
                        placeholder="Enter emails separated by commas"
                        helperText="Enter email addresses separated by commas"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Group sx={{ color: '#1284D3' }} />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <Button
                              size="small"
                              variant="outlined"
                              sx={{
                                ml: 1,
                                fontSize: '12px',
                                minWidth: 'auto',
                                padding: '6px 12px',
                                borderRadius: '6px',
                                textTransform: 'none',
                              }}
                              onClick={() => setContactsModalOpen(true)}
                            >
                              Add Contacts
                            </Button>
                          ),
                        }}
                        required
                        onFocus={() =>
                          meetingData.participants && setShowSuggestions(true)
                        }
                        onBlur={() =>
                          setTimeout(() => setShowSuggestions(false), 200)
                        }
                        sx={{
                          '& .MuiInputBase-root': {
                            borderRadius: '8px',
                          },
                        }}
                      />

                      {showSuggestions && filteredEmails.length > 0 && (
                        <Paper
                          elevation={3}
                          sx={{
                            position: 'absolute',
                            width: '100%',
                            maxHeight: 200,
                            overflow: 'auto',
                            zIndex: 1,
                            mt: 1,
                            borderRadius: '8px',
                          }}
                        >
                          <List>
                            {filteredEmails.map((user) => (
                              <ListItem
                                key={user._id}
                                button
                                onClick={() => {
                                  const parts = meetingData.participants.split(',');
                                  parts[parts.length - 1] = user.email;
                                  setMeetingData((prev) => ({
                                    ...prev,
                                    participants: parts.join(', ') + (parts.length > 0 ? ', ' : ''),
                                  }));
                                  setShowSuggestions(false);
                                }}
                                sx={{
                                  '&:hover': {
                                    backgroundColor: '#f5f5f5',
                                  },
                                }}
                              >
                                <ListItemText
                                  primary={user.email}
                                  secondary={`${user.firstName} ${user.lastName}`}
                                />
                              </ListItem>
                            ))}
                          </List>
                        </Paper>
                      )}
                    </Box>

                    <Stack
                      direction="row"
                      spacing={2}
                      justifyContent="flex-end"
                      sx={{ mt: 2 }}
                    >
                      <Button
                        variant="outlined"
                        sx={{
                          color: '#1284D3',
                          borderColor: '#1284D3',
                          fontFamily: "'Open Sans', sans-serif",
                          fontWeight: '500',
                          borderRadius: '8px',
                          px: 3,
                          '&:hover': {
                            backgroundColor: 'rgba(18, 132, 211, 0.04)',
                            borderColor: '#1284D3',
                          },
                        }}
                        onClick={() => {
                          setMeetingData({
                            title: '',
                            description: '',
                            date: '',
                            time: '',
                            duration: '30',
                            participants: '',
                          });
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{
                          backgroundColor: '#1284D3',
                          fontFamily: "'Open Sans', sans-serif",
                          fontWeight: '500',
                          borderRadius: '8px',
                          px: 4,
                          '&:hover': {
                            backgroundColor: '#0d6ba8',
                            transform: 'translateY(-1px)',
                            boxShadow: '0 4px 12px rgba(18, 132, 211, 0.3)',
                          },
                          transition: 'all 0.2s ease-in-out',
                        }}
                      >
                        Schedule Meeting
                      </Button>
                    </Stack>
                  </Stack>
                </form>
              </Paper>
            </Box>
          )}
        </div>
      </div>
      
      {/* Contacts Modal */}
      <Dialog
        open={contactsModalOpen}
        onClose={() => setContactsModalOpen(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '12px',
          },
        }}
      >
        <DialogTitle sx={{ 
          bgcolor: '#f5f5f5', 
          borderBottom: '1px solid #e0e0e0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <Typography variant="h6" fontWeight={600}>
            Select Contacts
          </Typography>
          <IconButton
            aria-label="close"
            onClick={() => setContactsModalOpen(false)}
            sx={{ 
              color: 'text.secondary',
              '&:hover': {
                color: 'text.primary',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          dividers
          sx={{ minHeight: 400, maxHeight: 500, overflowY: 'auto', p: 3 }}
        >
          <DropDown
            options={contactsOptions}
            value={selectedContacts}
            setter={setSelectedContacts}
            inputValue={contactsSearch}
            inputSetter={setContactsSearch}
            isMulti={true}
            placeholder="Search contacts by name or email"
            optionLabel="email"
            getOptionLabel={(c) =>
              `${c.firstName || ''} ${c.lastName || ''} (${c.email})`
            }
            optionValue="_id"
            isSearchable={true}
            autoFocus={true}
            label="Contacts"
            customStyle={{ minWidth: '100%' }}
            isLoading={contactsLoading}
          />
        </DialogContent>
        <DialogActions sx={{ p: 3, borderTop: '1px solid #e0e0e0' }}>
          <Button 
            onClick={() => setContactsModalOpen(false)} 
            color="secondary"
            sx={{ borderRadius: '6px' }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddContactsToParticipants}
            variant="contained"
            disabled={!selectedContacts || selectedContacts.length === 0}
            sx={{ borderRadius: '6px' }}
          >
            Add Selected Contacts
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CreateMeeting;